import Intro from './intro';
import About from './about';
import ImageBlock from './image-block';
import Gallery from './gallery';
import StatsBlock from './stats-block';
import TextBlock from './text-block';
import TitleBlock from './title-block';
import VideoBlock from './video-block';
import WorkLinks from './work-links';

export default {
    Intro,
    About,
    ImageBlock,
    Gallery,
    StatsBlock,
    TextBlock,
    TitleBlock,
    VideoBlock,
    WorkLinks
};



// WEBPACK FOOTER //
// ./src/components/index.js